const PageLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full min-h-screen bg-white">
      <div className="flex flex-col items-center gap-6">
        <img
          src="/svg/VT_logo_dashboard_header.svg"
          alt="VerifyToday"
          className="h-10 w-auto opacity-90"
        />
        <div className="flex flex-col items-center gap-3">
          <svg
            className="animate-spin h-9 w-9 text-blue-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          <p className="text-sm text-gray-400 tracking-wide">Loading...</p>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
